export default "__VITE_ASSET__0251d20f__"